@import 'styles/mixins';
@import 'styles/variables';

.loadingState {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  @include sm-regular;
}
